import React, { useState, useEffect } from 'react'
import { Table, Panel } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { useHistory } from 'react-router-dom'
import DownloadButton from '../../components/buttons/downloadButton/downloadButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'

export default function SearchLawResultTable({
  schema,
  dataKeyTable,
  pagination,
  onReload,
  loading,
  onDownload = () => {},
  onSelect = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [tableData, setTableData] = useState([])
  // const history = useHistory()

  // console.log('table schema ', schema)

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.values) {
      setTableData(schema.values)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  const getData = () => {
    return schema?.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  return (
    <>
      <Panel header={schema.header || 'แสดงรายงานคดี'} collapsible defaultExpanded bordered>
        <Table
          wordWrap
          minHeight={400}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
        >
          <Column width={70} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={100}>
            <HeaderCell>รหัสคดี</HeaderCell>
            <Cell dataKey="litigationCode" />
          </Column>

          <Column width={350}>
            <HeaderCell>ชื่อคดี</HeaderCell>
            <Cell dataKey="litigationName" />
          </Column>

          <Column width={250}>
            <HeaderCell>เลขที่สัญญา/รหัสอ้างอิงอื่นๆ</HeaderCell>
            <Cell dataKey="referCodeDocument" />
          </Column>

          <Column width={250} align="center">
            <HeaderCell>วันที่ทำสัญญา/วันที่อ้างอิงอื่นๆ</HeaderCell>
            <Cell dataKey="referDate" />
          </Column>

          <Column width={150}>
            <HeaderCell align="right">ทุนทรัพย์</HeaderCell>
            <Cell dataKey="capital" style={{ textAlign: 'right' }} />
          </Column>

          <Column width={285}>
            <HeaderCell align="right">จำนวนเงินที่เรียกร้องค่าเสียหาย</HeaderCell>
            <Cell dataKey="damages" style={{ textAlign: 'right' }} />
          </Column>

          <Column width={180} align="center">
            <HeaderCell>สถานะหนังสือ</HeaderCell>
            <Cell dataKey="status" />
          </Column>

          <Column width={140}>
            <HeaderCell>รหัสโครงการ</HeaderCell>
            <Cell dataKey="projectCode" />
          </Column>

          <Column width={320}>
            <HeaderCell>ชื่อโครงการ</HeaderCell>
            <Cell dataKey="projectName" />
          </Column>

          <Column width={180} align="center">
            <HeaderCell>ประเภทหนังสือ</HeaderCell>
            <Cell dataKey="docType" />
          </Column>

          <Column width={225} align="center">
            <HeaderCell>วันครบกำหนดอายุความ</HeaderCell>
            <Cell dataKey="limitationDate" />
          </Column>

          <Column width={235} align="center" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <ViewButton
                      icon="eye"
                      size="sm"
                      onClick={() => {
                        onSelect(rowData)
                      }}
                    ></ViewButton>

                    <DownloadButton
                      size="sm"
                      disabled={
                        rowData.pathFile == undefined ||
                        rowData.pathFile == null ||
                        rowData.pathFile == ''
                      }
                      style={{ marginLeft: 10 }}
                      onClick={() => {
                        onDownload(rowData.litigationCode, rowData.eContractId, rowData.pathFile)
                      }}
                    />
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema?.totalSize || 0}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}
      </Panel>
    </>
  )
}
